module.exports = __webpack_public_path__ + "img/ship.280110bd.png";